import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { DateTime } from 'luxon'
import useStyles from './thru-or-teetime.styles'

const ThruOrTeetime = (props) => {
  const {
    teeTime,
    thru,
    isEmbedView,
  } = props
  const styles = useStyles({ isEmbedView })
  const teeTimeFormatted = DateTime.fromISO(teeTime)
    .setLocale('en-US')
    .toLocaleString({ hour: 'numeric', minute: '2-digit', timeZoneName: 'short' })

  return (thru === '-') ? (
    <Box className={styles.tee}>
      <Typography variant="overline" color="textSecondary">
        Beginning
      </Typography>
      <Typography variant="body1">|</Typography>
      <Typography variant="h5">{teeTimeFormatted}</Typography>
    </Box>
  ) : (
    <Box className={styles.thruWrapper}>
      <Typography variant="overline">THRU</Typography>
      <Typography variant="h4">{thru}</Typography>
    </Box>
  )
}

ThruOrTeetime.propTypes = {
  teeTime: PropTypes.string,
  thru: PropTypes.string,
  isEmbedView: PropTypes.bool,
}

export default ThruOrTeetime
